import React, { useState } from 'react';
import { useApp } from '../../../context/AppContext';
import PageHeader from '../../../components/PageHeader/PageHeader';
import Input from '../../../components/Form/Input';
import Button from '../../../components/Form/Button';
import { useToast } from '../../../context/ToastContext';
import { apiService } from '../../../services/api';
import './Settings.css';

const AdminSettings = () => {
    const { settings, updateSettings } = useApp();
    const { showToast } = useToast();
    const [formData, setFormData] = useState({
        commission: settings.commission || 5,
        convenience_fee: settings.convenience_fee || 5,
        allowed_loyalty_points: settings.allowed_loyalty_points || 5,
        cashback_value: settings.cashback_value || 5,
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: parseFloat(value) || value,
        }));
    };

    // const handleSubmit = async (e) => {
    //     e.preventDefault();
    //     try {
    //         await apiService.updatePaymentSystem(formData);
    //         showToast('Payment system settings updated successfully!', 'success');
    //     } catch (error) {
    //         console.error('Error updating payment system:', error);
    //         showToast('Failed to update payment system settings.', 'error');
    //     }
    // };


    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            await apiService.updatePaymentSystem(formData);
            
            // ✅ keep context in sync so rest of app sees new values
            updateSettings(formData);
    
            showToast('Payment system settings updated successfully!', 'success');
        } catch (error) {
            console.error('Error updating payment system:', error);
            showToast('Failed to update payment system settings.', 'error');
        }
    };
    
    return (
        <div className="admin-settings">
            <PageHeader title="Settings" subtitle="Configure platform settings and rules" />

            <div className="settings-container">
                <form onSubmit={handleSubmit} className="settings-form">
                    <div className="settings-section">
                        <h2 className="settings-section-title">Payment System Configuration</h2>
                        <div className="settings-grid">
                            <Input
                                label="Commission (%)"
                                type="number"
                                name="commission"
                                value={formData.commission}
                                onChange={handleChange}
                                min="0"
                                max="100"
                                step="0.1"
                            />
                            <Input
                                label="Convenience Fee (₹)"
                                type="number"
                                name="convenience_fee"
                                value={formData.convenience_fee}
                                onChange={handleChange}
                                min="0"
                                step="0.01"
                            />
                            <Input
                                label="Allowed Loyalty Points"
                                type="number"
                                name="allowed_loyalty_points"
                                value={formData.allowed_loyalty_points}
                                onChange={handleChange}
                                min="0"
                            />
                            <Input
                                label="Cashback Value (₹)"
                                type="number"
                                name="cashback_value"
                                value={formData.cashback_value}
                                onChange={handleChange}
                                min="0"
                                step="0.01"
                            />
                        </div>
                    </div>

                    <div className="settings-actions">
                        <Button type="submit" variant="primary">
                            Save Settings
                        </Button>
                        <Button
                            type="button"
                            variant="outline"
                            onClick={() => setFormData({
                                commission: settings.commission || 5,
                                convenience_fee: settings.convenience_fee || 5,
                                allowed_loyalty_points: settings.allowed_loyalty_points || 5,
                                cashback_value: settings.cashback_value || 5,
                            })}
                        >
                            Reset
                        </Button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default AdminSettings;

